import hyperdom from 'hyperdom'
import BasePaymentMethod from './basePaymentMethod.jsx'

export default class Paypal extends BasePaymentMethod{
  constructor (payment) {
    super(payment)
    this.displayName = 'PayPal'
    this.messageKey = 'payment'
  }

  eligible () {
    return this.payment.isPayPalEligible()
  }

  renderTermsAndConditions () {}

  renderPaymentSummary () {}

  render () {
    return <div class='o-accent-box'>
      { this.payment.renderPaymentMethodSelection() }
      { this.payment.renderTermsAndConditions()}
      <div className='payment-summary__container'>
        {this._renderPaymentSummary()}
      </div>
    </div>
  }

  book () {
    return
  }

  _renderPaymentSummary () {
    let address = this.payment.quoteCriteria.leadPassenger.address
    const amount = this.payment.calculatePaymentAmount()
    this.payment.paypalButton.setPaymentParams({
      sellingCompanyCode: this.payment.config.sellingCompanyCode,
      bookingId: this.payment.booking.booking.bookingId,
      amount: amount,
      product: {
        name: this.payment.quoteCriteria.departure.name,
        quantity: 1,
        unitPrice: amount,
      },
      shippingAddress: {
        street1: address.line1,
        city: address.city,
        state: address.region,
        postalCode: address.postcode,
        country: address.country,
      },
      customer: {
        firstName: this.payment.quoteCriteria.leadPassenger.firstName,
        lastName: this.payment.quoteCriteria.leadPassenger.lastName,
      },
    })

    this.payment.paypalButton.validate = ({hideErrors} = {}) => {
      const validation = this.payment.validate()
      if (hideErrors) {
        this.payment.showValidationErrors = false
      }
      return validation
    }

    this.payment.paypalButton.onSuccess(paypalPayment => {
      this.payment.booking.paidViaPayPal(paypalPayment)
      this.payment.serverErrorsPanel.clear(this.messageKey)
      this.payment.switchToTab('confirmation')
      this.payment.hideLoading()
    })

    this.payment.paypalButton.onFailure((error) => {
      this.payment.serverErrorsPanel.setErrors(error, this.messageKey)
      this.refresh()
    })
    return <div className='payment-summary__cta'>
      {this.payment.renderPaymentAmount()}
      {this.payment.paypalButton}
    </div>
  }

  renderPaymentOption () {
    return [
      <div>{this.displayName}</div>,
      <ul class="u-unstyled cards">
        <li class="u-inbl u-margin-left-small card-icon">
          <img src="public/img/card-icons/paypal.svg" alt="paypal" />
        </li>
        <li class="u-inbl u-margin-left-small card-icon">
          <img src="public/img/card-icons/paypal-credit.svg" alt="paypal-credit" />
        </li>
      </ul>,
    ]
  }
}
